@if (sourceItem$ | async; as source) {
  @if (!source.icon && source.src) {
    <div
      class="zef-logo-image"
      [ngClass]="'zef-' + size + ' zef-' + shape"
      [style.background-image]="source.src | encodeURI: 'url' | safeStyle"
    ></div>
  }
  @if (source.icon && source.src) {
    <mat-icon [ngClass]="'zef-icon-' + iconSize" [color]="source.color">
      {{ source.src }}
    </mat-icon>
  }
}
